import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Report } from '@classes/report';
import { ReportType } from '@classes/report-type';
import { ReportValue } from '@enums/report-value.enum';
import { ReportService } from 'app/core/services/report.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import * as _moment from 'moment';
import { UiService } from 'app/core/services/ui.service';
const moment = _moment;

@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
  styleUrls: ['./report-list.component.scss'],
  styles: [`
  >>> app-report-list {
    display: flex;
    margin: auto;
  }
`]
})
export class ReportListComponent implements OnInit {

  reportListForm: FormGroup;

  ReportValue = ReportValue;

  categories: string[] = [];
  reports: ReportType[] = [];
  reportsByCategory: ReportType[] = [];
  filteredReports: Observable<ReportType[]> | undefined;

  placeHolder: string;
  constructor(
    public reportService: ReportService,
    private formBuilder: FormBuilder,
    public uiService: UiService
  ) {
    this._initList();
  }

  ngOnInit() {
    this.initForm();
  }

  private initForm(reportType?: ReportType) {
    const fb = this.formBuilder;
    this.reportListForm = fb.group({
      category: fb.control({ value: null, disabled: false }, [Validators.required]),
      type: fb.control({ value: null, disabled: false }, [Validators.required]),
      startDate: fb.control({ value: null, disabled: false }, []),
      endDate: fb.control({ value: null, disabled: false }, []),
      site: fb.control({ value: null, disabled: false }, []),
      company: fb.control({ value: null, disabled: false }, []),
      material: fb.control({ value: null, disabled: false }, []),
      year: fb.control({ value: null, disabled: false }, []),
    });

    this.reportListForm.controls.type.valueChanges.subscribe((data => {
      this.initValidator(data);
    }));
    this.reportListForm.controls.category.valueChanges.subscribe((category => {
      this.initTypeList(category);
      this.reportListForm.controls.type.setValue(null);
      this.initValidator();
    }));
  }

  private initValidator(reportType?: ReportType) {
    this.reportListForm.controls.startDate.setValidators(reportType?.startDate == ReportValue.Mandatory ? [Validators.required] : []);
    this.reportListForm.controls.startDate.updateValueAndValidity();
    this.reportListForm.controls.endDate.setValidators(reportType?.endDate == ReportValue.Mandatory ? [Validators.required] : []);
    this.reportListForm.controls.endDate.updateValueAndValidity();
    this.reportListForm.controls.site.setValidators(reportType?.site == ReportValue.Mandatory ? [Validators.required] : []);
    this.reportListForm.controls.site.updateValueAndValidity();
    this.reportListForm.controls.company.setValidators(reportType?.company == ReportValue.Mandatory ? [Validators.required] : []);
    this.reportListForm.controls.company.updateValueAndValidity();
    this.reportListForm.controls.material.setValidators(reportType?.material == ReportValue.Mandatory ? [Validators.required] : []);
    this.reportListForm.controls.material.updateValueAndValidity();
    this.reportListForm.controls.year.setValidators(reportType?.year == ReportValue.Mandatory ? [Validators.required] : []);
    this.reportListForm.controls.year.updateValueAndValidity();
  }

  private _initList() {
    this.reportService.getReportTypes().subscribe(reports => {

      reports.map(m => m.category)
        .sort((a, b) => ((a || "") > (b || "")) ? 1 : (((b || "") > (a || "")) ? -1 : 0))
        .forEach(f => {
          if (f != null && !this.categories.includes(f)) {
            this.categories.push(f);
          }
        });
      this.reports = reports
        .sort((a, b) => ((a.name || "") > (b.name || "")) ? 1 : (((b.name || "") > (a.name || "")) ? -1 : 0));
    }, error => {
      console.error(error);
    })
  }

  private _initFilteredReports(): void {
    this.filteredReports = this.reportListForm.controls.type.valueChanges
      .pipe(
        startWith(''),
        map(value => {
          if (typeof value === 'string') {
            return this._filter(value);
          }
          return []
        })
      );
  }


  private _filter(value: string): ReportType[] {
    const filterValue = value.toLowerCase();
    return this.reports.filter(option => (option.name || '').toLowerCase().includes(filterValue));
  }

  displayFn(report?: ReportType): string {
    return report ? (report.name || '') : '';
  }

  private initTypeList(category: string) {
    this.reportsByCategory = this.reports.filter(f => f.category == category);
  }

  onSubmit() {
    this.uiService.addRouteLoading();
    const params = new Report(this.reportListForm.value);
    params.type = this.reportListForm.controls.type.value.type;
    params.startDate = this.reportListForm.controls.startDate.value ? moment(this.reportListForm.controls.startDate.value).format('YYYY-MM-DD') : null;
    params.endDate = this.reportListForm.controls.endDate.value ? moment(this.reportListForm.controls.endDate.value).format('YYYY-MM-DD') : null;
    params.siteId = this.reportListForm.controls.site.value?.id;
    params.companyId = this.reportListForm.controls.company.value?.id;
    params.materialId = this.reportListForm.controls.material.value?.id;
    params.year = this.reportListForm.controls.year.value || null;
    this.reportService.getReport(params).subscribe(data => {
      let fileName = data.headers.get('content-disposition')
        .split(";")
        .find((f: string) => f.startsWith(" filename="))
        .replace(" filename=", "");
      if (fileName.startsWith('\"')) {
        fileName = fileName.substring(1);
      }
      if (fileName.endsWith('\"')) {
        fileName = fileName.slice(0, -1);
      }

      this.reportService.downloadBlob(fileName, data.body);
      this.uiService.removeRouteLoading();
    }, error => {
      this.uiService.removeRouteLoading();
    });
  }
}
